import MomentUtils from '@date-io/moment';
import { useContextSelector } from '@fluentui/react-context-selector';
import { Grid } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Loading } from '_screens';
import { MuiPickersUtilsProvider } from 'material-ui-pickers';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { Booking } from '@aps-management/primapp-common';

import { Screen } from '_components/core';
import NotFound from '_screens/Public/NotFound';
import { useScaling } from '_utils/scalingUtil';

import PublicBookingHeader from './PublicBookingHeader';
import PublicBookingOptions from './PublicBookingOptions';
import PublicBookingContext from './services/publicBookingService';

/* */
const styles = () => ({
  container: {
    backgroundColor: 'transparent',
    display: 'grid !important',
    gridTemplateColumns: '1fr 1fr 1fr',
    gridTemplateRows: 'auto 35px 1fr',
    gridTemplateAreas: `
      "title title title"
      "header header header"
      "main main main"`,
    minHeight: 0,
  },
});

/* */
const PublicBooking = ({ classes }) => {
  const [error] = useState(null);
  const [success] = useState(null);
  const { isMobileView } = useScaling();
  const {
    loading: publicBookingLoading,
    data: { courses },
  } = useContextSelector(PublicBookingContext, (c) => c);

  if (publicBookingLoading && !courses) return <Loading />;
  if (!publicBookingLoading && courses && courses.length === 0) return <NotFound />;

  return (
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <Screen noDrawer layout='fluid-large' error={error} success={success}>
        <Grid
          className={classes.container}
          style={{
            height: !isMobileView ? 'calc(100vh - 75px)' : 'auto',
            maxHeight: !isMobileView ? 'calc(100vh - 75px)' : 'none',
          }}
        >
          <PublicBookingHeader />
          <PublicBookingOptions />
        </Grid>
      </Screen>
    </MuiPickersUtilsProvider>
  );
};

/* */
const mapStateToProps = ({ app: { golf }, bookingData, bookingSearch }) => ({
  golf,
  data: bookingData,
  search: bookingSearch,
});
export default connect(mapStateToProps, Booking.actions)(withRouter(withStyles(styles)(PublicBooking)));
